import { Modal, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { QrCodeIcon, LogoutIcon } from "../../assets";
import { Button } from "../../components";
import { onQRCodeLogin } from "../../services/firebaseRealTimeDatabase";
import { getClientById, getWalletByClient } from "../../services/totem";
import { useStore } from "../../store";
import { useUserManager } from "../../store/hooks";
import { Wallet } from "../../types";
import useStyles from "./styles";

export const MarketHome: React.FC = () => {
  const Styles = useStyles();
  const { userManager, userTotem, navigation } = useStore();
  const [qrCodeModalOpen, setQrCodeModalOpen] = useState<boolean>(false);

  const handleStartClick = () => {
    // Navigate to market purchase as guest
    navigation.navigateTo("/market-purchase");
  };

  const handleQRCodeClick = () => {
    setQrCodeModalOpen(true);
  };

  const performLogin = async (clientId: any) => {
    setQrCodeModalOpen(false);
    if (clientId && clientId.client) {
      const res = await getClientById(clientId.client);

      if (res) {
        res.wallet = (await getWalletByClient(clientId.client)) as Wallet;
        userTotem.login({ ...res, loginMethod: 'qr_code' });
        navigation.navigateTo("/market-purchase");
      }
    }
  };

  const handleLogout = () => {
    navigation.navigateTo("/login-admin", {
      state: {
        isLogount: true,
      },
    });
  };

  const deviceId = localStorage.getItem("MenuPass@TotemHash") as string;

  useEffect(() => {
    const unsubscribe = onQRCodeLogin(userManager.entity, userManager.id, deviceId, performLogin);
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  return (
    <div className={Styles.container}>
      <div className={Styles.content}>
        <Typography className={Styles.title}>Bem-vindo!</Typography>
        <Typography className={Styles.subtitle}>
          Escolha como deseja continuar
        </Typography>
        <Button size="large" onClick={handleStartClick}>
          Iniciar
        </Button>

        <div className={Styles.link} onClick={handleQRCodeClick}>
          <QrCodeIcon />
          <Typography component="span">Entrar com QR Code</Typography>
        </div>
      </div>

      <QrCodeModal
        open={qrCodeModalOpen}
        onClose={() => setQrCodeModalOpen(false)}
      />

      <div className={Styles.adminActions}>
        <div className={Styles.action} onClick={handleLogout}>
          <LogoutIcon />
        </div>
      </div>
    </div>
  );
};

interface QrCodeModalProps {
  open: boolean;
  onClose: () => void;
}

const QrCodeModal: React.FC<QrCodeModalProps> = ({ open, onClose }) => {
  const Styles = useStyles();
  const manager = useUserManager();

  const getQrCodeValue = () =>
    `${manager.entity}/${manager.id}/${localStorage.getItem("MenuPass@TotemHash")}`;

  return (
    <Modal open={open} className={Styles.modal}>
      <div className={Styles.modalView}>
        <div className={Styles.close} onClick={onClose}>
          <Close />
        </div>

        <QRCode value={getQrCodeValue()} size={195} />

        <Typography component="span">
          Use seu celular para escanear o QR-Code
        </Typography>
      </div>
    </Modal>
  );
};
